<script setup>
import PostSaleAssignmentModal from './PostSaleAssignmentModal.vue';
import PostSaleCancellationModal from './PostSaleCancellationModal.vue';

defineProps({
  action: { type: String, default: '' },
  agents: { type: Array, default: () => [] },
  assigning: { type: Boolean, default: false },
  cancelling: { type: Boolean, default: false },
  caseData: { type: Object, default: null },
  loadingAgents: { type: Boolean, default: false },
});

const emit = defineEmits(['assign', 'cancel', 'close']);
</script>

<template>
  <PostSaleAssignmentModal
    :agents="agents"
    :assigning="assigning"
    :loading-agents="loadingAgents"
    :show="action === 'assign'"
    @close="emit('close')"
    @confirm="emit('assign', $event)"
  />
  <PostSaleCancellationModal
    v-if="caseData"
    :case-data="caseData"
    :is-loading="cancelling"
    :show="action === 'cancel'"
    @close="emit('close')"
    @confirm="emit('cancel', $event)"
  />
</template>
